export const routes = (prefix, pre) => [
    {
        name: `${prefix}.${pre}.mpesa-pay-report.index`,
        path: `/${prefix}/${pre}/mpesa-pay-report`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.mpesa-pay-report.index`,
                PageDescription: "Accounts/Finance Reports: M-pesa report",
            },
        },
    },
    {
        name: `${prefix}.${pre}.mpesa-pay.print`,
        path: `/${prefix}/${pre}/mpesa-pay/print/:ReceiptNo`,
        component: () => import('./modals/CombinedInvoice.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.received-payments-report.index`,
                PageDescription: "Accounts/Finance Reports: Received Payments report",
            },
            print: true,
        },
    },
];